import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { StatusBanner } from '@xingternal/banner';
import { Hyperlink } from '@xingternal/hyperlink';
import { mediaSmallOrTiny } from '@xingternal/layout-tokens';
import { spaceM, spaceXL } from '@xingternal/tokens';
import { Column } from '@xingternal/xing-grid';

import { ExternalUrlDescription } from '@/graphql/generated';

type Props = {
  description: ExternalUrlDescription;
};

const Banner = styled(StatusBanner)`
  @media ${mediaSmallOrTiny} {
    margin-bottom: ${spaceXL};
  }
`;

const Headline = styled.span`
  display: block;
  margin-bottom: ${spaceM};
`;

export const NoConsentExternalURLMessage: React.VFC<Props> = ({ description }) => (
  <Column size={12}>
    <Banner variant="info" display="inline">
      <FormattedMessage id="JOBS_DETAIL_EXTERNAL_URL_DESCRIPTION_NO_TRACKING_CONSENT_HEADLINE">
        {(text) => <Headline>{text}</Headline>}
      </FormattedMessage>
      <FormattedMessage
        id="JOBS_DETAIL_EXTERNAL_URL_DESCRIPTION_NO_TRACKING_CONSENT_LINK"
        values={{
          link: (
            <FormattedMessage id="JOBS_DETAIL_EXTERNAL_URL_DESCRIPTION_NO_TRACKING_CONSENT_LINK_CONTENT">
              {(text) => (
                <Hyperlink target="_blank" rel="noopener" href={description.url}>
                  {text}
                </Hyperlink>
              )}
            </FormattedMessage>
          ),
        }}
      />
    </Banner>
  </Column>
);
